const TYPOGRAPHY_SIZE = {
  heading: [
    {
      fontSize: "48px",
      lineHeight: "64px",
      fontWeight: "bold"
    },
    {
      fontSize: "40px",
      lineHeight: "56px",
      fontWeight: "medium"
    },
    {
      fontSize: "36px",
      lineHeight: "48px",
      fontWeight: "medium"
    },
    {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: "bold"
    }
  ],
  title: [
    {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "bold"
    },
    {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: "bold"
    },
    {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  subtitle: [
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "medium"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  body: [
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "regular"
    },
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "medium"
    }
  ],
  caption: [
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "regular"
    },
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "medium"
    },
    {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "medium"
    }
  ]
};
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const getTypographySize = (type, level = 1, attr) => {
  const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
  return tagAttrs[attr];
};

export { FONT_WEIGHT_MAP, TYPOGRAPHY_SIZE, getTypographySize };
